module.exports = __webpack_public_path__ + "static/img/4_3_1.386ce005.jpg";